export const modals = () => {
	newsletter()
}

const newsletter = () => {

	const modal = document.querySelector('[data-el="newsletter-modal"]')

	if ( !modal ) return

	const openButtons = document.querySelectorAll('[data-function="open-newsletter-modal"]')
	const closeButtons = modal.querySelectorAll('[data-function="close-newsletter-modal"]')

	function openModal(button) {
		modal.classList.add('active')
		document.body.classList.add('modal-open')
		modal.setAttribute('aria-hidden', 'false')
		openButtons.forEach(btn => btn.setAttribute('aria-expanded', btn === button ? 'true' : 'false'))
		modal.querySelector('input, button[type="submit"]').focus()
	}

	function closeModal() {
		modal.classList.remove('active')
		document.body.classList.remove('modal-open')
		modal.setAttribute('aria-hidden', 'true')
		openButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'))
	}

	openButtons.forEach(button => {
		button.addEventListener('click', () => openModal(button))
	})

	closeButtons.forEach(button => {
		button.addEventListener('click', closeModal)
	})

	modal.addEventListener('click', (e) => {
		if (e.target === modal) closeModal()
	})

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && modal.classList.contains('active')) closeModal()
	})
}

export default () => { }